module.exports = __webpack_public_path__ + "static/img/xcxNew.2c19201.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xcxNew.jpg
// module id = k+1+
// module chunks = 0